import { Button, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import React from 'react';

import MHButton from '../../MHButton';
import { CalendarModalTestID } from './CalendarModal.models';
import { useStyles } from './CalendarModal.styles';
import { CalendarModalIconPositive } from './CalendarModalIconPositive';

interface Props {
  onClose: () => void;
  sendToAuthUrl: () => void;
}

export const CalendarModalDeletedToZeroView: React.FC<Props> = ({ onClose, sendToAuthUrl }) => {
  const classes = useStyles();

  return (
    <DialogContent
      className={classes.dialogContent}
      data-testid={CalendarModalTestID.DeletedToZeroView}
    >
      <div className={classes.deleteConfirmContainer}>
        <div className={classes.iconDisplayContainer}>
          <div className={classes.iconDisplayBg}>
            <CalendarModalIconPositive />
          </div>
        </div>
        <DialogTitle className={classes.deleteConfirmTitle}>
          It seems like there are no connected calendars
        </DialogTitle>
        <Typography className={classes.deleteConfirmText}>
          Connect your calendar and let clients book directly with you. This could triple the number
          of sessions that are booked with you.
        </Typography>
        <div className={classes.deleteConfirmButtonContainer}>
          <Button
            onClick={onClose}
            variant="outlined"
            className={classes.padRight}
            data-testid={CalendarModalTestID.CloseButton}
          >
            Back to Dashboard
          </Button>
          <MHButton onClick={sendToAuthUrl} data-testid={CalendarModalTestID.AddCalendarButton}>
            Connect Calendar
          </MHButton>
        </div>
      </div>
    </DialogContent>
  );
};
